import React from 'react';
import {
  CoverSliderSection,
  SliderContainer,
  SliderImage,
  SliderControls,
  SliderButton,
  SliderIndicators,
  SliderDot,
  SliderOverlay
} from '../styles/EventSidebar.styles';

const EventSlider = ({ 
  eventImages, 
  currentSlideIndex, 
  nextSlide, 
  prevSlide, 
  goToSlide, 
  onImageClick,
  eventTitle 
}) => {
  if (!eventImages || eventImages.length === 0) return null;

  return (
    <CoverSliderSection>
      <SliderContainer>
        {eventImages.map((image, index) => (
          <SliderImage
            key={image.id || index}
            src={image.url}
            alt={image.alternativeText || `${eventTitle} - immagine ${index + 1}`}
            isActive={index === currentSlideIndex}
            onClick={() => onImageClick(image)}
            onError={(e) => {
              console.error('Errore caricamento immagine slider:', image.url);
              e.target.style.display = 'none';
            }}
          />
        ))}
        
        {/* Controlli Slider */}
        {eventImages.length > 1 && (
          <>
            <SliderControls>
              <SliderButton onClick={prevSlide} aria-label="Immagine precedente">
                ‹
              </SliderButton>
              <SliderButton onClick={nextSlide} aria-label="Immagine successiva">
                ›
              </SliderButton>
            </SliderControls>
            
            {/* Indicatori */}
            <SliderIndicators>
              {eventImages.map((_, index) => (
                <SliderDot
                  key={index}
                  isActive={index === currentSlideIndex}
                  onClick={() => goToSlide(index)}
                  aria-label={`Vai all'immagine ${index + 1}`}
                />
              ))}
            </SliderIndicators>
            
            {/* Overlay con numero immagini */}
            <SliderOverlay>
              {currentSlideIndex + 1} / {eventImages.length}
            </SliderOverlay>
          </>
        )}
      </SliderContainer>
    </CoverSliderSection>
  );
};

export default EventSlider;
